import React, { Component } from 'react'
import noImage from '../../images/no_image.png'
export default class UserBlock extends Component {
  image() {
    if(this.props.user && this.props.user.photo) {
      return <img className='rounded-circle' height="80" width="80" src={this.props.user.photo} alt='' />
    } else {
      return <img height="80" src={noImage} alt='' />
    }
  }

  getGB() {
    var attrs = this.props.user.user_display_list_attributes
    if(attrs.length !== 0) {
      return 'Governing Body'
    }
  }

  // TODO: create a getModerator() method

  render() {
    let noHover = this.props.noHover === true ? '' : 'hover'
    if(!this.props.user) {
      return (
        <div className={'user-list ' + noHover}>
          <img height="80" src={noImage} alt='Anonymous' />
          <div className='user-info'>
            <div className='user-fullname'><strong>Anonymous</strong></div>
          </div>
        </div>
      )
    }
    return (
      <div className={'user-list ' + noHover}>
        {this.image()}
        <div className='user-info'>
          <div className='user-fullname'><strong>{this.props.user.first_name} {this.props.user.last_name}</strong></div>
          <div className='user-title'>{this.props.user.title}</div>
          <div className='user-org'>{this.props.user.organization_name}</div>
          <div className='user-gb'>{this.getGB()}</div>
        </div>
      </div>
    )
  }
}
